
import axios from 'axios';


class FormsService{

    async post(formData){
        const response = await axios.post("https://forms.mbk777.com/forms/mbk777v5", formData);
        //const response = await axios.post("http://localhost:5737/forms/local", formData);
        return response.data;
    }
}

export default new FormsService();